import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Card,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
} from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import * as actions from '../../redux/actions';
import Loading from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';
import dayjs from '../../utils/functions/thDayjs';

function ContainerMaintenance({ title, subtitle }) {
  const dispatch = useDispatch();
  const container = useSelector((state) => state.container);

  const [searchTerm, setSearchTerm] = useState('');
  const [name, setName] = useState('');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [total, setTotal] = useState(undefined);

  useEffect(() => {
    dispatch(actions.containerAll({ name, page, size }));
    dispatch(actions.vehicletypeAll({ size: null }));
  }, [name, page, size]);

  useEffect(() => {
    setTotal(container?.total);
    return () => {};
  }, [container]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setName(searchTerm);
      setPage(1);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const handleChangeRowsPerPage = (event) => {
    setSize(event.target.value);
    setPage(1);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
  };

  const renderSearch = () => (
    <Card>
      <div className="p-4 flex flex-row">
        <div className="w-full md:w-1/2">
          <TextField
            label="ค้นหา"
            fullWidth
            size={'small'}
            id="outlined-start-adornment"
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fas fa-search"></i>
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>
    </Card>
  );

  const renderTable = () => (
    <div className="my-2">
      <Paper>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <div className="font-bold">ลำดับที่</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold"> ป้ายทะเบียน</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold"> รายละเอียด</div>
                </TableCell>

                <TableCell>
                  <div className="font-bold"> ดำเนินการ</div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!_.isEmpty(container.rows) ? (
                container.rows.map((row, index) => (
                  <TableRow
                    key={row._id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {(page - 1) * size + index + 1}
                    </TableCell>
                    <TableCell>
                      <div className="font-semibold text-base font-sans">
                        {`${row?.licence_number}`}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className="text-sm">ขนาด {row?.size || '-'} </div>
                      <div className="text-sm">
                        น้ำหนัก {row?.weight || '-'}{' '}
                      </div>
                    </TableCell>

                    <TableCell>
                      <div className="flex flex-row flex-wrap gap-1">
                        <Link to={`container/detail/${row?._id}`}>
                          <Button variant="contained" size="small">
                            รายละเอียด{' '}
                          </Button>
                        </Link>
                        {/* <Link to={`/fms/vehicle/edit/${row?._id}`}>
                          <Button
                            variant="contained"
                            color="warning"
                            size="small"
                          >
                            แก่ไขข้อมูลรถ{' '}
                          </Button>
                        </Link> */}
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6}>
                    <div className="text-center">ไม่มีข้อมูล</div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          onRowsPerPageChange={handleChangeRowsPerPage}
          page={page - 1}
          count={total || 1}
          rowsPerPage={size}
          onPageChange={handleChangePage}
        />
      </Paper>
    </div>
  );

  if (container.isLoading) {
    return <Loading />;
  }
  if (!container.isLoading && container.isCompleted) {
    return (
      <div>
        {renderTitle()}

        {renderSearch()}
        {renderTable()}
      </div>
    );
  }
  return <Error />;
}

ContainerMaintenance.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

ContainerMaintenance.defaultProps = {
  title: '',
  subtitle: '',
};

export default ContainerMaintenance;
